import { render, staticRenderFns } from "./AccountManageLinkItem.vue?vue&type=template&id=39b33dce&"
import script from "./AccountManageLinkItem.vue?vue&type=script&lang=js&"
export * from "./AccountManageLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./AccountManageLinkItem.vue?vue&type=style&index=0&id=39b33dce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/AccountManageLinkItem.vue
// module id = null
// module chunks = 